export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_day_389.89c6e8f0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};